module.exports = __webpack_public_path__ + "static/media/radio-button-focused.f6a81cbd.svg";